/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventcreated1Inputs */

const en_eventcreated1 = /** @type {(inputs: Eventcreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event created!`)
};

const de_eventcreated1 = /** @type {(inputs: Eventcreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event erstellt!`)
};

/**
* | output |
* | --- |
* | "Event created!" |
*
* @param {Eventcreated1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventcreated1 = /** @type {((inputs?: Eventcreated1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventcreated1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventcreated1(inputs)
	return de_eventcreated1(inputs)
});
export { eventcreated1 as "eventCreated" }